import { render, staticRenderFns } from "./sh_AcceptInvite.vue?vue&type=template&id=85fee0f6&scoped=true&"
import script from "./sh_AcceptInvite.vue?vue&type=script&lang=js&"
export * from "./sh_AcceptInvite.vue?vue&type=script&lang=js&"
import style0 from "./sh_AcceptInvite.vue?vue&type=style&index=0&id=85fee0f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fee0f6",
  null
  
)

export default component.exports